<template>
  <div class="publication-manager">
    <common-button
      v-if="hasControls && hasPublications"
      class="uk-margin"
      icon="plus"
      :disabled="disabled"
      @click="newPublication"
    >
      {{$t('actions.addPublication')}}
    </common-button>

    <publication-form
      ref="formModal"
      :values="editedPublication"
      :publications="publications"
      @submit="submitPublication"
      @hidden="resetEditedPublication"
    />

    <publication-table
      v-if="hasPublications"
      :publications="publications"
      :show-actions="showTableActions"
      @edit="editPublication"
      @remove="removePublication"
    />

    <div v-else class="uk-placeholder uk-margin-remove-top uk-text-center">
      <div>
        <icon name="warning" />
        {{$t('hints.noPublications')}}
      </div>

      <common-button
        v-if="hasControls"
        class="uk-margin"
        icon="plus"
        :disabled="disabled"
        @click="newPublication"
      >
        {{$t('actions.addPublication')}}
      </common-button>
    </div>
  </div>
</template>

<script>
import { cloneDeep, sortBy } from 'lodash';
import CommonButton from '@/components/CommonButton';
import PublicationForm from '@/components/PublicationForm';
import PublicationTable from '@/components/PublicationTable';

function sortPublications(publications) {
  return sortBy(publications, p => p.tenant.name.toLowerCase());
}

export default {
  name: 'publication-manager',
  components: {
    CommonButton,
    PublicationForm,
    PublicationTable,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
    hasControls: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value(value) {
      this.publications = sortPublications(cloneDeep(value || []));
    },
  },
  data() {
    return {
      publications: sortPublications(cloneDeep(this.value || [])),
      editedPublicationIndex: null,
    };
  },
  computed: {
    hasPublications() {
      return this.publications.length > 0;
    },
    editedPublication() {
      if (this.editedPublicationIndex === null) return null;
      return this.publications[this.editedPublicationIndex];
    },
    showTableActions() {
      return this.hasControls && !this.disabled;
    },
  },
  methods: {
    newPublication() {
      this.resetEditedPublication();
      this.$refs.formModal.show();
    },
    editPublication(index) {
      this.editedPublicationIndex = index;
      this.$refs.formModal.show();
    },
    submitPublication(price) {
      const { publications } = this;
      if (this.editedPublicationIndex === null) {
        publications.push(price);
      } else {
        publications[this.editedPublicationIndex] = price;
      }
      this.publications = sortPublications(publications);
      this.$refs.formModal.hide();
      this.onInput();
    },
    removePublication(index) {
      this.publications.splice(index, 1);
      this.onInput();
    },
    resetEditedPublication() {
      this.editedPublicationIndex = null;
    },
    onInput() {
      this.$emit('input', this.publications);
      this.$emit('change', this.publications);
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          addPublication: 'Publikation hinzufügen',
        },
        hints: {
          noPublications: 'Es wurden keine Mandanten zugeordnet.',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// PublicationManager.vue?39addf30